import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import {
    Header,
    Footer,
} from '@usb-onboarding/product-recommender-components';
import {
    getRecommendedResults,
    resetQuestionnaire,
} from '../../redux/actions';
import Loader from '../../atoms/Loader';
import Recommendations from '../../molecules/Recommendations';
import FooterNav from '../../molecules/FooterNav';
import { tealiumConfiguration } from '../../config';
import { productID } from '../../constants';
import {
    getResultsReportingData,
    dispatchReportingEvent,
    mapTealiumRecommendations,
    tealiumUpdatedPageView,
    tealiumUpdatedClick,
} from '../../utils';

const { aemUrl } = window.__conf__;

function RecommendationsPage() {
    const dispatch = useDispatch();
    const history = useHistory();

    const error = useSelector((state) => state.errorReducer.error);
    const recommendations = useSelector(
        (state) => state.resultsReducer.recommendedResults,
    );
    const recommendationsLoaded = useSelector(
        (state) => state.resultsReducer.recommendedResultsLoaded,
    );
    const AEMContent = useSelector(
        (state) => state.AEMContentReducer.AEMContent,
    );
    const sessionID = useSelector(
        (state) => state.questionnaireReducer.sessionID,
    );
    const isLoading = useSelector(
        (state) => state.loaderReducer.isLoading,
    );

    useEffect(() => {
        if (recommendations.length < 1) {
            dispatch(getRecommendedResults(productID));
        }
    }, []);

    useEffect(() => {
        if (recommendationsLoaded) {
            const tealiumConfig = tealiumConfiguration[productID];
            const { siteSection, subSiteSection } = tealiumConfig;

            const currentPage =
                recommendations.length > 1
                    ? AEMContent.resultPage.titleMulti.toLowerCase()
                    : AEMContent.resultPage.title.toLowerCase();

            const reportingData = getResultsReportingData(
                currentPage,
                siteSection,
                subSiteSection,
                mapTealiumRecommendations(recommendations),
            );
            dispatchReportingEvent(reportingData);
            tealiumUpdatedPageView();

            window.scrollTo(0, 0);
        }
    }, [recommendationsLoaded]);

    useEffect(() => {
        if (!sessionID) {
            history.push('/start');
        }
    }, [sessionID]);

    useEffect(() => {
        if (error) {
            history.push('/tech-trouble');
        }
    }, [error]);

    function goToAllResults() {
        history.push('/all-products');
    }

    function buttonCallback(action, product) {
        if (window.reportingData) {
            const reportingData = JSON.parse(
                JSON.stringify(window.reportingData),
            );
            reportingData.onClickEvent = action.toLowerCase();
            reportingData.productsRecommended = product.toLowerCase();
            dispatchReportingEvent(reportingData);
            tealiumUpdatedClick();
        }
    }

    function restartRecommender() {
        dispatch(resetQuestionnaire());
    }

    const pageTitle =
        recommendations.length > 1
            ? AEMContent.resultPage.titleMulti
            : AEMContent.resultPage.title;

    const pageContent =
        recommendations.length > 1
            ? AEMContent.resultPage.contentMulti
            : AEMContent.resultPage.content;

    return (
        <>
            {isLoading && <Loader />}
            <Header title={AEMContent.header.fullName} />
            <Helmet>
                <title>
                    Results page | Product recommender | U.S. Bank
                </title>
            </Helmet>
            <main id="app__content">
                <Recommendations
                    buttonCallback={buttonCallback}
                    title={pageTitle}
                    content={pageContent}
                    imageUrl={`${aemUrl}${AEMContent.resultPage.imageUrl}`}
                    recommendations={recommendations}
                    goToAllResults={goToAllResults}
                    restartRecommender={restartRecommender}
                />
            </main>
            <FooterNav
                link={AEMContent.backButtonLink}
                text={AEMContent.backButtonText}
            />
            <Footer
                header={AEMContent.footer.connectionTitle}
                content={AEMContent.footer.footerDisclosure}
                privacyLabel={AEMContent.footer.privacyLabel}
                privacyUrl={AEMContent.footer.privacyUrl}
                fdic={AEMContent.footer.connectionContent}
                cobrowseLabel={AEMContent.footer.cobrowseLabel}
                cobrowseUrl={AEMContent.footer.cobrowseUrl}
            />
        </>
    );
}

export default RecommendationsPage;
